<template>
  <div>
    <template v-if="lastLogin">
      <h2>Letzter Login</h2>
      <p>{{ lastLogin | formatDate('date-time') }} Uhr</p>
    </template>

    <h2>Vergütung</h2>
    <p>{{ compensation | formatCurrency }} / Stunde zzgl. MwSt.</p>

    <h2>Website</h2>
    <p>
      <a
        :href="website"
        target="_blank"
        rel="noopener"
      >
        {{ website }}
      </a>
    </p>

    <h2>Mitgliedschaften</h2>
    <ul class="memberships">
      <li
        v-for="(membership, key) in memberships"
        :key="key"
      >
        <span
          class="memberships__icon"
          :class="`el-icon-circle-${membership.isMember ? 'check' : 'close-outline'}`"
        />
        {{ membership.name }}
      </li>
    </ul>

    <template v-if="documentTraining || documentCertificate">
      <h2>Dokumente</h2>
      <ul>
        <li v-if="documentTraining">
          <a
            :download="documentTraining.filename"
            :href="documentTraining.url"
            target="_blank"
          >
            Unterlagen zur Ausbildung
          </a>
        </li>
        <li v-if="documentCertificate">
          <a
            :download="documentCertificate.filename"
            :href="documentCertificate.url"
            target="_blank"
          >
            Zertifikate
          </a>
        </li>
      </ul>
    </template>

    <el-button
      v-if="!isApproved"
      :loading="approveStatus === $config.status.LOADING"
      round
      type="success"
      @click="approve"
    >
      Freischalten
    </el-button>

    <el-button
      :loading="removeStatus === $config.status.LOADING"
      round
      type="danger"
      @click="remove"
    >
      Coach löschen
    </el-button>
  </div>
</template>

<script>
import api from '@/api'
import filenameFromHeader from '@/functions/filenameFromHeader'
import formatCurrency from '@/functions/formatCurrency'
import formatDate from '@/functions/formatDate'

export default {
  name: 'CCoachAdmin',

  filters: {
    formatCurrency,
    formatDate
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    lastLogin: {
      type: Date
    },
    compensation: {
      type: Number,
      required: true
    },
    website: {
      type: String,
      required: true
    },
    memberships: {
      type: Object,
      required: true
    },
    isApproved: {
      type: Boolean
    }
  },

  data () {
    return {
      approveStatus: this.$config.status.IDLE,
      removeStatus: this.$config.status.IDLE,
      documentTraining: null,
      documentCertificate: null
    }
  },

  created () {
    this.getTraining()
    this.getCertificate()
  },

  destroyed () {
    if (this.documentTraining && this.documentTraining.url) {
      URL.revokeObjectURL(this.documentTraining.url)
    }

    if (this.documentCertificate && this.documentCertificate.url) {
      URL.revokeObjectURL(this.documentCertificate.url)
    }
  },

  methods: {
    getTraining () {
      api.coach
        .getTraining(this.id)
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] })
          const url = URL.createObjectURL(blob)
          const filename = filenameFromHeader(response.headers['content-disposition'])

          this.documentTraining = { url, filename }
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Die Ausbildungs-Unterlagen konnten nicht geladen werden.'
          })
        })
    },
    getCertificate () {
      api.coach
        .getCertificate(this.id)
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] })
          const url = URL.createObjectURL(blob)
          const filename = filenameFromHeader(response.headers['content-disposition'])

          this.documentCertificate = { url, filename }
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Die Zertifikate konnten nicht geladen werden.'
          })
        })
    },
    approve () {
      if (!window.confirm('Möchten Sie dieses Konto wirklich freischalten?')) {
        return
      }

      this.approveStatus = this.$config.status.LOADING

      api.coach
        .approve(this.id)
        .then(() => {
          this.approveStatus = this.$config.status.SUCCESS
          this.$emit('change')
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Das Konto konnte leider nicht freigeschaltet werden.'
          })

          this.approveStatus = this.$config.status.ERROR
        })
    },
    remove () {
      if (!window.confirm('Möchten Sie dieses Konto wirklich löschen?')) {
        return
      }

      this.removeStatus = this.$config.status.LOADING

      api.coach
        .deleteAccount(this.id)
        .then(() => {
          this.removeStatus = this.$config.status.SUCCESS
          this.$router.push({ name: 'coach-list' })
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Das Konto konnte leider nicht gelöscht werden.'
          })

          this.removeStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.memberships {
  list-style: none;
  padding-left: 0;
}

.memberships__icon {
  margin-right: 0.375em;
}
</style>
